import React from 'react';
import { ValidationPage as ValidationComponent } from '@components/features/validation';

const ValidationPage: React.FC = () => {
  return <ValidationComponent />;
};

export default ValidationPage;